import { FC } from "react";

import { DynamicInputProps } from "../types";



const TextFieldComp: FC<DynamicInputProps> = ({ label, name, render_condition, data_required, display, isHidden, id, group, state, updateValue }): JSX.Element => {
  return display ? (
    <div className={`form-group row py-3 ${render_condition !== "" ? "bg-light" : ""} ${isHidden ? "d-none" : ""}`}>
      <label htmlFor={name} className="col-sm-4 form-label text-end precert-form-label">
        {label} {data_required && "*"}
      </label>
      <div className="col-sm-8">
        <input
          type={name.includes("id") ? "number" : "text"}
          className="form-control"
          name={name}
          id={name}
          required={data_required}
          value={state[name]}
          onChange={(e) => updateValue(e.target.value, id, group)}
        />
      </div>
    </div>
  ) : <></>;
}

export default TextFieldComp
